import firebase from 'firebase'
import 'firebase/firestore'

var config = {
  apiKey: 'AIzaSyAxvk68PbRppVD02ub4w11VXVWphfi97q4',
  authDomain: "pokemeetspizza.firebaseapp.com",
  databaseURL: "https://pokemeetspizza.firebaseio.com",
  projectId: "pokemeetspizza",
  storageBucket: "pokemeetspizza.appspot.com",
  messagingSenderId: "203921490013"
};
firebase.initializeApp(config);
const db = firebase.firestore()
const provider = new firebase.auth.GoogleAuthProvider()
export {
  db, firebase, provider
}
